export default {
  'Resize for': 'サイズを変更する',
  'Add 10 videos at most': 'ビデオ 10 個を最大限に追加する',
}